import { Component, EventEmitter, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LinkEmaAccountsComponent } from '../link-ema-accounts/link-ema-accounts.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UniversalIdFormComponent, UserLink, EnterpriseLabels, getEnterpriseLabels, SecurityDomain } from 'lib';
import { DatePipe } from '@angular/common';
import { EnterpriseLabelsFetchService } from '../../services/enterprise-labels-fetch.service';

@Component({
    selector: 'mmoga-create-universal-id',
    standalone: true,
    imports: [UniversalIdFormComponent, LinkEmaAccountsComponent, FormsModule, ReactiveFormsModule],
    providers: [DatePipe],
    templateUrl: './create-universal-id.component.html',
    styleUrl: './create-universal-id.component.scss'
})
export class CreateUniversalIdComponent implements OnInit {
    activeModal = inject(NgbActiveModal);
    private readonly enterpriseLabelsFetchService = inject(EnterpriseLabelsFetchService);

    @Input() currentEnterpriseId!: number;

    createUniversalIdEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
    userLinksEvent: EventEmitter<UserLink[]> = new EventEmitter<UserLink[]>();
    universalIdDetailsValid = false;
    linkEmaAccountsValid = false;
    enterpriseLabels: EnterpriseLabels = getEnterpriseLabels(SecurityDomain.MODMED);

    ngOnInit() {
        this.enterpriseLabelsFetchService.getEnterpriseLabels().then(
            labels => this.enterpriseLabels = labels
        );
    }

    public cancel() {
        this.activeModal.close(false);
    }

    universalIdCreationValidation(event: { valid: boolean }): void {
        this.universalIdDetailsValid = event.valid;
    }

    linkEmaAccountsFormUpdated(event: { value: UserLink[], valid: boolean }) {
        this.userLinksEvent.emit(event.value);
        this.linkEmaAccountsValid = event.valid;
    }

    onSubmit(): void {
        this.activeModal.dismiss();
    }

    create(): void {
        this.createUniversalIdEvent.emit(true);
    }

    public closeModal() {
        this.activeModal.dismiss();
    }
}


